<template>
  <van-config-provider style="height:100vh;" :theme-vars="themeVars">
    <Frame
      class="page-frame"
      :loading="loading"
      :finished="finished"
      @onLoad="onLoadFrame"
      @onRefresh="onRefreshFrame"
    >
      <template v-slot:header>
        <div class="header">
          <CustomHeader
            v-if="hasNavHeader"
            :left-arrow="true"
            left-text="访客记录"
            :theme-vars="themeVars"
          />
          <TabToggle
            v-if="(plateformType === 'DingTalkMini' || plateformType === 'WeChatMiniProgram') && userType == 'teacher'"
            :default-id="1"
            @onChange="tabIdChange"
          />
          <van-dropdown-menu
            active-color="#4275FD"
            v-if="
              (plateformType === 'DingTalkMini' || plateformType === 'WeChatMiniProgram') &&
              userType == 'teacher' &&
              tabIndex == 1
            "
          >
            <van-dropdown-item :title="visitTypeItem.name" ref="dropitem1">
              <FilterRadio
                :key="1"
                :default-id="visitTypeItem.id"
                :list="visitorTypeList"
                @onChange="visitorTypeChange"
              />
            </van-dropdown-item>
          </van-dropdown-menu>
          <van-dropdown-menu
            active-color="#4275FD"
            v-if="
              (plateformType === 'DingTalkMini' || plateformType === 'WeChatMiniProgram') &&
              userType == 'teacher' &&
              tabIndex == 2
            "
          >
            <van-dropdown-item :title="visitTypeItem.name" ref="dropitem1">
              <FilterRadio
                :key="1"
                :default-id="visitTypeItem.id"
                :list="visitorTypeList"
                @onChange="visitorTypeChange"
              />
            </van-dropdown-item>
            <van-dropdown-item :title="recordTypeItem.name" ref="dropitem2">
              <FilterRadio
                :key="2"
                :default-id="recordTypeItem.id"
                :list="recordTypeList"
                @onChange="recordTypeChange"
              />
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </template>
      <template v-slot:body>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :finished-text="
              finished && list.length >= 10 ? '--没有更多了--' : ''
            "
            @load="onLoad"
          >
            <VisitorRecordItem
              :user-type="userType"
              :key="item"
              :detail="item"
              :record-type-list="recordTypeList"
              v-for="item in list"
              @clickEvt="toDetail"
            />
            <van-empty
              v-if="list.length <= 0 && finished"
              class="custom-image"
              :image="require('@/assets/image/no-data.png')"
              description="暂无数据"
            />
          </van-list>
        </van-pull-refresh>
      </template>
      <template v-slot:footer>
        <div
          class="footer"
          v-if="plateformType !== 'webapp' && userType == 'teacher'"
        >
          <van-button class="van-button" type="primary" @click="toVisitorApply"
            >代访客预约</van-button
          >
        </div>
        <div class="footer-double" v-else>
          <van-button
            class="van-button"
            plain
            round
            type="primary"
            @click="toVisitorApply"
            >申请访客</van-button
          >
          <van-button class="van-button" round type="primary" @click="toLogin"
            >访客码</van-button
          >
        </div>
      </template>
    </Frame>
  </van-config-provider>
</template>

<script>
import Frame from "@/components/frame.vue"
import CustomHeader from "@/components/customHeader/index.vue"
import TabToggle from "./components/tabToggle.vue"
import VisitorRecordItem from "./components/visitorRecordItem.vue"
import FilterRadio from "./components/filterRadio.vue"
import { Toast } from "vant"
import { ref, computed } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
export default {
  name: "VisitorRecord",
  components: {
    Frame,
    CustomHeader,
    TabToggle,
    VisitorRecordItem,
    FilterRadio,
  },
  setup() {
    const store = useStore()
    const router = useRouter()

    const schoolCode = store.state.schoolCode
    const idNumber = store.state.idNumber
    const phone = store.state.phone

    //   自定义主题
    const themeVars = {
      navBarTextColor: "#333",
      dropdownMenuBackgroundColor: "transparent",
      dropdownMenuBoxShadow: "none",
      dropdownMenuTitleFontSize: "15px",
      dropdownMenuTitleTextColor: "#333",
      cellLineHeight: "54px",
      cellVerticalPadding: "0px",
      cellHorizontalPadding: "0px",
    }

    const plateformType =
      computed(() => store.getters.plateformType) || "webapp"
    const userType = computed(() => store.state.userType)
    const hasNavHeader = computed(() => store.getters.hasNavHeader)

    // 顶部tabToggle
    const tabIndex = ref(1)
    const tabIdChange = (item) => {
      console.log(item)
      // if (item.id == 1) {
      //   recordTypeItem.value = {
      //     id: 10000,
      //     name: "全部状态",
      //   }
      // }
      tabIndex.value = item.id
      onRefresh()
    }

    // 类型筛选
    const dropitem1 = ref(null)
    const dropitem2 = ref(null)

    // 访问类型
    const visitTypeItem = ref({
      id: 10000,
      name: "全部类型",
    })
    let visitorTypeList = ref([])
    const openDictionary = (params) =>
      store.dispatch("visitor/openDictionary", params)
    const getOpenDictionary = async () => {
      let params = {
        schoolCode: schoolCode,
      }
      let r = await openDictionary(params)
      if (r.message == "success") {
        let list = r.data.list || []
        list.unshift({ id: 10000, code: 10000, name: "全部类型" })
        list.map((item) => {
          item.id = item.code
        })
        visitorTypeList.value = r.data.list || []
      } else {
        Toast.fail(r.message)
      }
    }
    getOpenDictionary()
    const visitorTypeChange = (item) => {
      visitTypeItem.value = item
      setTimeout(() => {
        dropitem1.value.toggle(false)
        onRefresh()
      }, 200)
    }

    // 记录类型
    const recordTypeItem = ref({
      id: 10000,
      name: "全部状态",
    })
    const recordTypeList = ref([
      {
        id: 10000,
        name: "全部状态",
      },
      {
        id: 0,
        name: "待审批",
      },
      {
        id: 1,
        name: "已拒绝",
      },
      {
        id: 2,
        name: "未拜访",
      },
      {
        id: 4,
        name: "已拜访",
      },
      {
        id: 5,
        name: "已过期",
      },
    ])
    const recordTypeChange = (item) => {
      recordTypeItem.value = item
      setTimeout(() => {
        dropitem2.value.toggle(false)
        onRefresh()
      }, 200)
    }

    // 刷新及获取列表数据
    const list = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    const pageNum = ref(1)
    const pageSize = ref(30)

    const openPage = (params) => store.dispatch("visitor/openPage", params)
    const teacherAppPage = (params) =>
      store.dispatch("visitor/teacherAppPage", params)
    const parentAppPage = (params) =>
      store.dispatch("visitor/parentAppPage", params)

    const getDataSource = async () => {
      let params = {
        pageNum: pageNum.value,
        pageSize: pageSize.value,
      }
      if (plateformType.value === "DingTalkMini" || plateformType.value === "WeChatMiniProgram") {
        let isProcessed = tabIndex.value == 2
        let appointmentDictionaryCode =
          visitTypeItem.value && visitTypeItem.value.id
        if (appointmentDictionaryCode === 10000) {
          appointmentDictionaryCode = ""
        }
        let actualDirection = recordTypeItem.value && recordTypeItem.value.id
        if (actualDirection === 10000) {
          actualDirection = ""
        }
        params = Object.assign({}, params, {
          appointmentDictionaryCode,
          actualDirection,
        })
        if (userType.value == "teacher") {
          params.isProcessed = isProcessed
        }
      } else {
        params.idNumber = idNumber
        params.phone = phone
        params.schoolCode = schoolCode
      }
      let r = null
      if (plateformType.value === "DingTalkMini" || plateformType.value === "WeChatMiniProgram") {
        if (userType.value == "teacher") {
          r = await teacherAppPage(params)
        } else {
          r = await parentAppPage(params)
        }
      } else {
        r = await openPage(params)
      }
      let { success, data, message } = r
      if (success) {
        if (refreshing.value) {
          list.value = []
          refreshing.value = false
        }
        list.value.push(...data.list)
        loading.value = false
        pageNum.value++
        if (list.value.length >= data.total) {
          finished.value = true
        }
      } else {
        refreshing.value = false
        finished.value = true
        loading.value = false
        Toast.fail(message)
      }
    }

    const onLoad = () => {
      getDataSource()
    }

    const onRefresh = () => {
      // 清空列表数据
      list.value = []
      pageNum.value = 1
      finished.value = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true
      onLoad()
    }

    // 跳转访客申请页面
    const toVisitorApply = () => {
      router.push({
        path: "/visitorApply",
      })
    }

    const toDetail = (detail) => {
      router.push({
        path: "/visitorRecordDetail",
        query: {
          id: detail.id,
        },
      })
    }

    const toLogin = () => {
      if (plateformType.value === "DingTalkMini" || plateformType.value === "WeChatMiniProgram") {
        router.push({
          path: "/indexParent",
        })
      } else {
        router.push({
          path: "/login",
        })
      }
    }

    return {
      dropitem1,
      dropitem2,
      themeVars,
      hasNavHeader,
      plateformType,
      userType,
      tabIndex,
      visitTypeItem,
      visitorTypeList,
      recordTypeItem,
      recordTypeList,
      list,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      tabIdChange,
      visitorTypeChange,
      recordTypeChange,
      toVisitorApply,
      toLogin,
      toDetail,
    }
  },
}
</script>

<style lang="less" scoped>
.page-frame {
  height: 100vh;
  background-color: #f2f4f9;
  .footer {
    background-color: #fff;
    text-align: center;
    .van-button {
      width: 345px;
      height: 36px;
      border-radius: 18px;
      margin: 6px auto;
    }
  }
  .footer-double {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: 6px 15px;
    .van-button {
      width: 150px;
      height: 36px;
    }
  }
}
/deep/ .van-dropdown-menu .van-dropdown-menu__bar {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  .van-dropdown-menu__item {
    display: flex;
    flex: 0 1 80px;
  }
}
/deep/ .van-list {
  min-height: 60vh;
}
/deep/ .van-empty__image {
  width: 180px;
  height: 150px;
}
/deep/ .van-list__finished-text {
  font-size: 12px;
}
/deep/ .van-radio-group {
  background-color: #f2f4fa;
  .van-cell {
    background-color: #f2f4fa;
  }
}
</style>
